import { DragState } from "@/wbcontroller/ImageUploadController";
import { WBOperationManagerState } from "@/wbcontroller/operations/OperationManager";
import makeTypeSafeCommitter from "../makeTypeSafeCommitter";

export interface ReportedState {
  undo: WBOperationManagerState;
  zoom: {
    isAllowed: boolean;
    scale: number;
    minScale: number;
    maxScale: number;
    scaleSteps: number[];
  };
  dragState: DragState;
  isOffline: boolean;
}

const mutations = {
  setScale(state: ReportedState, scale: number) {
    state.zoom.scale = scale;
  },
  replaceUndoState(state: ReportedState, undoState: WBOperationManagerState) {
    state.undo = undoState;
  },
  setOfflineState(state: ReportedState, isOffline: boolean) {
    state.isOffline = isOffline;
  },
  setDragState(state: ReportedState, dragState: DragState) {
    state.dragState = dragState;
  },
};
type ReportedMutationsWithState = typeof mutations;

export const ReportedMutations = makeTypeSafeCommitter<
  ReportedState,
  typeof mutations
>(mutations);

const getters = {};
type ReportedGettersWithState = typeof getters;
export type ReportedGetters = {
  [Property in keyof ReportedGettersWithState]: ReturnType<
    ReportedGettersWithState[Property]
  >;
};

export function makeReportedModule(isZoomAllowed: boolean): {
  state: () => ReportedState;
  mutations: ReportedMutationsWithState;
  getters: ReportedGettersWithState;
} {
  return {
    state: () => ({
      isOffline: false,
      selectedShapes: [],
      undo: {
        canUndo: false,
        canRedo: false,
        undoLabel: null,
        redoLabel: null,
      },
      zoom: {
        isAllowed: isZoomAllowed,
        scale: 1,
        minScale: 0.125,
        maxScale: 4,
        scaleSteps: [0.125, 0.25, 0.5, 1, 1.5, 2, 3, 4],
      },
      dragState: DragState.none,
    }),
    mutations,
    getters,
  };
}
